"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Plugin = void 0;

var _cuid = _interopRequireDefault(require("cuid")),
    _webviewProtocol = require("@daangn/webview-protocol"),
    _createMessage = require("./createMessage"),
    _isWebView = require("./isWebView");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var Plugin = /*#__PURE__*/function () {
  function Plugin(a, b) {
    _classCallCheck(this, Plugin);

    this.driver = a, this.stream = b;
  }

  _createClass(Plugin, [{
    key: "open",
    value: function open(_ref) {
      var a = _ref.remote,
          b = _ref.app,
          c = _ref.path,
          d = _ref.height,
          e = _ref.disableClose,
          f = _ref.onClose;

      if ((0, _isWebView.isWebView)()) {
        var g = (0, _cuid.default)();
        this.driver.postMessage((0, _createMessage.createMessage)({
          type: _webviewProtocol.Type.ReqPluginOpen,
          payload: {
            plugin: {
              remote: a,
              app: b,
              path: c,
              height: d,
              disableClose: e,
              closeEventName: g
            }
          }
        })), this.stream.on(g, function () {
          null === f || void 0 === f ? void 0 : f();
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      (0, _isWebView.isWebView)() && this.driver.postMessage((0, _createMessage.createMessage)({
        type: _webviewProtocol.Type.ReqPluginClose
      }));
    }
  }, {
    key: "style",
    value: function style(_ref2) {
      var a = _ref2.height,
          b = _ref2.disableClose;
      (0, _isWebView.isWebView)() && this.driver.postMessage((0, _createMessage.createMessage)({
        type: _webviewProtocol.Type.ReqPluginStyle,
        payload: {
          plugin: {
            height: a,
            disableClose: b
          }
        }
      }));
    }
  }]);

  return Plugin;
}();

exports.Plugin = Plugin;